/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-10 11:16:05
 * @LastEditors: steFan
 * @LastEditTime: 2020-03-24 17:43:54
 */
let str = localStorage.getItem('dowUrl');
str = str ? JSON.parse(JSON.stringify(str)) : '';

let jackpotUrl = localStorage.getItem('jackpotUrl');
jackpotUrl = jackpotUrl ? JSON.parse(JSON.stringify(jackpotUrl)) : '';

let customerServiceUrl = localStorage.getItem('customerServiceUrl');
// customerServiceUrl = customerServiceUrl ? JSON.parse(JSON.stringify(customerServiceUrl)) : '';
export default {
    host: 'http://159.138.131.189', //新测试环境
    loginVersion: 'v1.0.0',
    baseUrl: '',
    dowUrl: str || 'https://appdownload.011312.com/',
    PTUrl: window.PTUrl || 'https://installer.hotspin88.com/download/AndroidCasino.apk',
    jackpotUrl: jackpotUrl,
    customerServiceUrl: customerServiceUrl,
    ws: 500,
    hs: 500,
    scales: 0.8,
    // 页面服务器
    codeUrl: '',
    // 图片服务器
    imgHost: '',
    appVer: '1.0.0',
    protocolVer: '1.0',
    reqId: 0,
    numVer: 'v2.0.1',
    themeIndex: sessionStorage.getItem("theme"),
    clientIp: '101.231.217.194',
    fingerprint:'', //设备唯一标识
    phoneModel:'',//设备型号
    pcYijiUrl: '', // pc易记域名图片
    captchaId: window.childCode  === 'jsht' ? '0913c2211cfb25e513793a02ee311222' : 'b7f5fc9ea916acc391a2f8f8c1738d4a'
};